import _extends from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @author Harmeet
 */import React from 'react';
import styled from 'styled-components';
import styles from './GlobalFooter.style';
import Footer from '../../molecules/Footer';
import FooterNva from '../../molecules/FooterNva';
import { locationLabels } from '../../../constants/labels/en';
import { parseWorkingHours } from '../../../utils/utilityFunction';
import constants from '../../../constants/globalConstants';
import analyticsConstants from '../../../constants/analyticsConstants';
import { FORM_SUBMISSION_THANKYOU } from '../../../constants/labels/en';
var GlobalFooterBlock = styled.section.withConfig({
  componentId: "sc-1tmcds5-0"
})(["", ";"], styles);
var GlobalFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(GlobalFooter, _React$Component);
  var _super = _createSuper(GlobalFooter);
  function GlobalFooter(props) {
    var _this;
    _classCallCheck(this, GlobalFooter);
    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }
  _createClass(GlobalFooter, [{
    key: "render",
    value: function render() {
      var themeName = this.props.themeName;
      var globalFooterProps = this.props.globalFooterData;
      var variation = globalFooterProps && globalFooterProps.variation || 'Variation-A';
      var multiLocationMenuContainers = globalFooterProps.multiLocationContainer;
      var yextData = this.props.yextContactInformationData;
      var footerLogo = this.props.footerLogo;
      var _parseWorkingHours = parseWorkingHours(yextData && yextData.hours, yextData && yextData.c_extendedHours),
        perDayHoursDetailArray = _parseWorkingHours.perDayHoursDetailArray,
        extendedHoursDetailArray = _parseWorkingHours.extendedHoursDetailArray,
        nameOfDay = _parseWorkingHours.nameOfDay;
      var dto = {
        variation: variation,
        googleMyBusinessCID: yextData && yextData.c_googleMyBusinessCID,
        locationName: yextData && yextData.name,
        multiLocationMenuContainers: multiLocationMenuContainers,
        addressObject: {
          classNameAnchor: '',
          classNameHeading: '',
          classNamePara: 'address-block',
          paraHeadingClass: 'heading_three',
          paraText: yextData && yextData.name,
          ariaLabel: locationLabels.address,
          address: yextData && yextData.address,
          copyRightText: yextData && yextData.name
        },
        copyRightObject: {
          copyRightText: yextData && yextData.name
        },
        contactUsObject: {
          paraClassName: variation === constants.variations.variationA ? '' : 'left',
          paraText: variation === constants.variations.variationA ? '' : 'Contact Us',
          paraTextClass: 'heading_three',
          phone: yextData && yextData.c_websitePhone || yextData && yextData.mainPhone,
          phoneText: variation === constants.variations.variationA ? locationLabels.T : locationLabels.phone,
          fax: yextData && yextData.fax,
          faxText: variation === constants.variations.variationA ? locationLabels.F : locationLabels.fax,
          email: yextData && yextData.emails,
          emailText: variation === constants.variations.variationA ? locationLabels.E : locationLabels.email,
          contactAddressObject: variation === constants.variations.variationA ? null : {
            classNamePara: 'address-block',
            ariaLabel: locationLabels.address,
            address: yextData && yextData.address
          },
          addressText: variation === constants.variations.variationA ? null : locationLabels.addressCamelCase,
          emergencyText: locationLabels.emergency && locationLabels.emergency === 'undefined' ? locationLabels.emergency : null
        },
        hoursOfOperationObject: {
          classNameParaHeading: 'heading_three',
          ariaLabel: locationLabels.hoursofoperation,
          paraText: locationLabels.hoursofoperation,
          mainHoursText: locationLabels.mainhours,
          extendedHours: false,
          perDayHoursDetailArray: perDayHoursDetailArray,
          extendedHoursDetailArray: extendedHoursDetailArray,
          nameOfDay: nameOfDay,
          hoursTextLine: yextData && yextData.additionalHoursText,
          extendedHoursTextLine: yextData && yextData.c_extendedAdditionalHoursText
        },
        logoImage: {
          src: footerLogo && footerLogo.url,
          alt: footerLogo && footerLogo.title,
          title: footerLogo && footerLogo.title,
          contentType: footerLogo && footerLogo.contentType
        },
        mapImage: {
          src: globalFooterProps && globalFooterProps.map && globalFooterProps.map.image && globalFooterProps.map.image.url,
          alt: globalFooterProps && globalFooterProps.map ? globalFooterProps.map.altText : '',
          title: globalFooterProps && globalFooterProps.map ? globalFooterProps.map.title || globalFooterProps.map.altText : '',
          contentType: globalFooterProps && globalFooterProps.map && globalFooterProps.map.image && globalFooterProps.map.image.contentType
        },
        mapUrlOverride: globalFooterProps && globalFooterProps.mapUrlOverride,
        primaryLinksObject: globalFooterProps && globalFooterProps.primaryLinksCollection && globalFooterProps.primaryLinksCollection.items ? globalFooterProps.primaryLinksCollection.items : null,
        utilityLinksObject: globalFooterProps && globalFooterProps.utilityLinksCollection && globalFooterProps.utilityLinksCollection.items ? globalFooterProps.utilityLinksCollection.items : null,
        socialIconsData: globalFooterProps && globalFooterProps.socialLinks ? globalFooterProps.socialLinks : null,
        dataAnalyticsLogo: {
          type: 'footer-logo',
          value: 'footer-logo',
          variation: variation
        },
        dataAnalyticsAddress: {
          type: 'address-box',
          value: 'address-box',
          variation: variation
        },
        dataAnalyticsPrimaryLinks: {
          type: 'footer-primary',
          value: 'footer-primary',
          variation: variation
        },
        dataAnalyticsSecondaryLinks: {
          type: 'footer-secondary',
          value: 'footer-secondary',
          variation: variation
        },
        dataAnalyticsSocialLinks: {
          type: 'footer-social-feed',
          value: 'footer-social-feed',
          variation: variation
        },
        miniFooterCTA: globalFooterProps && globalFooterProps.miniFooterCta
      };
      var contactUsNvaObject = {
        submitUrl: globalFooterProps.formUrl,
        successfulSubmissionMessage: globalFooterProps.successfulSubmissionMessage || FORM_SUBMISSION_THANKYOU,
        reCaptchaKey: this.props.reCaptchaKey
      };
      var NVAdto = {
        locationName: yextData && yextData.name,
        googleMyBusinessCID: yextData && yextData.c_googleMyBusinessCID,
        footerHeadline: globalFooterProps && globalFooterProps.formHeadline,
        contactUsNvaObject: contactUsNvaObject,
        footerSubHeadline: globalFooterProps && globalFooterProps.formSubheadline,
        footerMessage: globalFooterProps && globalFooterProps.formBody && globalFooterProps.formBody.json,
        logoImage: {
          src: footerLogo && footerLogo.url,
          alt: footerLogo && footerLogo.title,
          title: footerLogo && footerLogo.title,
          contentType: footerLogo && footerLogo.contentType
        },
        addressObject: {
          copyRightText: yextData && yextData.name
        },
        primaryLinksObject: null,
        utilityLinksObject: globalFooterProps && globalFooterProps.utilityLinksCollection && globalFooterProps.utilityLinksCollection.items ? globalFooterProps.utilityLinksCollection.items : null,
        socialIconsData: globalFooterProps && globalFooterProps.socialLinks ? globalFooterProps.socialLinks : null,
        dataAnalyticsLogo: {
          type: analyticsConstants.nvaFooter.analyticsType.FOOTER_LOGO_TYPE,
          value: analyticsConstants.nvaFooter.analyticsValue.FOOTER_LOGO_VALUE,
          variation: variation
        },
        dataAnalyticsAddress: {
          type: analyticsConstants.nvaFooter.analyticsType.ADDRESS_BOX_TYPE,
          value: analyticsConstants.nvaFooter.analyticsValue.ADDRESS_BOX_VALUE,
          variation: variation
        },
        dataAnalyticsPrimaryLinks: {
          type: analyticsConstants.nvaFooter.analyticsType.FOOTER_PRIMARY_TYPE,
          value: analyticsConstants.nvaFooter.analyticsValue.FOOTER_PRIMARY_VALUE,
          variation: variation
        },
        dataAnalyticsSecondaryLinks: {
          type: analyticsConstants.nvaFooter.analyticsType.FOOTER_SECONDARY_TYPE,
          value: analyticsConstants.nvaFooter.analyticsValue.FOOTER_SECONDARY_VALUE,
          variation: variation
        },
        dataAnalyticsSocialLinks: {
          type: analyticsConstants.nvaFooter.analyticsType.FOOTER_SOCIAL_FEED_TYPE,
          value: analyticsConstants.nvaFooter.analyticsValue.FOOTER_SOCIAL_FEED_VALUE,
          variation: variation
        }
      };
      return __jsx(GlobalFooterBlock, {
        globalFooterProps: globalFooterProps,
        className: "nva-global-footer-old organism globalFooter"
      }, globalFooterProps && globalFooterProps.formUrl ? __jsx(FooterNva, _extends({}, NVAdto, {
        globalFooterProps: globalFooterProps
      })) : __jsx(Footer, _extends({}, dto, {
        globalFooterProps: globalFooterProps,
        themeName: themeName
      })));
    }
  }]);
  return GlobalFooter;
}(React.Component);
GlobalFooter.defaultProps = {
  dataContentFul: '',
  inheritedstyles: {},
  aria: {}
};
export default styled(GlobalFooter).withConfig({
  componentId: "sc-1tmcds5-1"
})(["", ";"], styles);
export { GlobalFooter as GlobalFooterVanilla };